module.exports = __webpack_public_path__ + "img/JobDisqualified.578407d8.svg";